// extracted by mini-css-extract-plugin
module.exports = {"superscript":"styles-module--superscript--3C7TY"};